<template>
  <div class="task-form p-3">
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-6 mb-3">
            <label for="toMail" class="form-label">Select To Mail</label>
            <multiselect
              v-model="form.to_mail"
              :options="processedConcernPersonInfo"
              track-by="email"
              label="name"
              :multiple="true"
              placeholder="Select To Mail"
              @update:modelValue="handleToMailSelection"
            >
            </multiselect>
          </div>
          <div class="col-md-6 mb-3">
            <label for="sender" class="form-label"> Sender Name </label>
            <input
              type="text"
              id="sender"
              class="form-control"
              placeholder="Enter Sender Name"
              v-model="form.sender"
              required
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 mb-3">
            <label for="subject" class="form-label">
              Mail Subject <span class="text-danger">*</span>
            </label>
            <input
              type="text"
              id="subject"
              class="form-control"
              placeholder="Enter mail subject"
              v-model="form.subject"
              required
            />
            <div class="text-danger" v-if="errors.subject">
              {{ errors.subject[0] }}
            </div>
          </div>
          <div class="col-md-12 mb-3">
            <label for="mailBody" class="form-label">
              Mail Body <span class="text-danger">*</span>
            </label>
            <textarea
              id="mailBody"
              class="form-control"
              placeholder=""
              v-model="form.body"
              rows="4"
            ></textarea>
            <div class="text-danger" v-if="errors.body">
              {{ errors.body[0] }}
            </div>
          </div>
          <div class="col-md-6 mb-3">
            <label for="attachments" class="form-label">Attachment</label>
            <div class="d-grid">
              <label class="btn btn-outline-primary">
                <i class="fas fa-upload"></i>
                Add New
                <input
                  type="file"
                  id="attachments"
                  class="d-none"
                  @change="handleFileUpload"
                />
              </label>
            </div>
            <div v-if="form.attachment" class="mt-2 text-muted">
              <small
                ><strong>Selected File:</strong>
                {{ form.attachment.name }}</small
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-12 mt-3">
    <div class="d-flex justify-content-end">
      <button class="btn btn-success" @click="saveEmail">
        <span v-if="!isLoading">Send Mail</span>
        <span v-else>Loading...</span>
      </button>
    </div>
  </div>
</template>

<script>
import http from "@/utils/http";
import { isMultiple } from "ant-design-vue/es/vc-select/BaseSelect";
import Multiselect from "vue-multiselect";

export default {
  props: {
    leadId: {
      type: String,
      required: true,
    },
    concernPersonInfo: {
      type: Array,
      required: true,
    },
  },
  components: {
    Multiselect,
  },
  data() {
    return {
      isLoading: false,
      form: {
        to_mail: [],
        sender: "",
        subject: "",
        body: "",
        attachment: null,
      },

      errors: {},
    };
  },
  mounted() {
    const fullPath = this.$route.fullPath;
    const lastPart = fullPath.split("/").filter(Boolean).pop();
    this.currentPath = lastPart;
  },
  watch: {},
  computed: {
    processedConcernPersonInfo() {
      const allOption = { name: "ALL", email: "" };
      return [
        allOption,
        ...this.concernPersonInfo.map((person) => ({
          name: person.name,
          email: person.email[0],
        })),
      ];
    },
  },
  methods: {
    handleToMailSelection(selected) {
      const selectedOptions = Array.isArray(selected) ? selected : [selected];

      let allSelected = false;
      for (let option of selectedOptions) {
        if (option.email === "") {
          allSelected = true;
          break;
        }
      }

      if (allSelected) {
        this.form.to_mail = this.processedConcernPersonInfo.filter(
          (option) => option.email !== ""
        );
      }
    },

    handleFileUpload(event) {
      const selectedFile = event.target.files[0];
      if (selectedFile) {
        this.form.attachment = selectedFile;
      }
    },

    async saveEmail() {
      this.isLoading = true;
      const endpoint = "/store-leads-details-email-info";
      const method = "post";
      const formData = new FormData();

      formData.append("lead_id", this.leadId);
      formData.append("subject", this.form.subject);
      formData.append("body", this.form.body);
      formData.append("sender_name", this.form.sender);
      formData.append(
        "key_account",
        this.currentPath == "key-account-details" ? "Y" : "N"
      );
      // formData.append(
      //     'to_mail',
      //     JSON.stringify(this.form.to_mail.map((person) => person.email))
      // );
      const emailList = this.form.to_mail.map((person) => person.email);
      formData.append("to_mail", JSON.stringify(emailList));

      if (this.form.attachment) {
        formData.append("attachment", this.form.attachment);
      }
      try {
        const response = await http[method](endpoint, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        this.$toast.success(response.data.message);
        this.$emitter.emit("form-submitted");
        this.errors = {};
        this.isLoading = false;
        this.form = {
          to_mail: "",
          subject: "",
          body: "",
          attachment: null,
        };
      } catch (error) {
        this.isLoading = false;
        this.errors = error.response.data.errors;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>
